import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { CacheService } from './cache.service';
import { ItemLibrary } from '../model/classes/itemLibrary.class';
import { ItemParametrization } from '../model/classes/ItemParametrization.class';

@Injectable()
export class ItemLibraryService {
  baseUrl = 'api/ItemLibrary';

  constructor(private sxHttp: SxHttpService, private cacheService: CacheService) { }

  /**
   * get all libraries to the system selected
    */
  getAll(systemCode: string = null): Observable<ItemLibrary[]> {
    return this.sxHttp
      .get(`${this.baseUrl}/getAll`)
      .map(response => response.json().data as ItemLibrary[]);
  }

  getBySystem(systemCode: string = null): Observable<ItemLibrary[]> {
    return this.sxHttp
      .get(`${this.baseUrl}/getBySystem/${systemCode}`)
      .map(response => response.json().data as ItemLibrary[]);
  }

  /**
   * get all products configurations and templates libraries to the system selected
    */
  getProducts(systemCode: string = null): Observable<ItemLibrary[]> {
    return this.sxHttp
      .get(`${this.baseUrl}/getProducts/${systemCode}`)
      .map(response => response.json().data as ItemLibrary[]);
  }


  /**
   * Return a library from the backend
   * @param id the Id to search
   */
  getLibrary(id: string): Observable<ItemLibrary> {
    return this.sxHttp
      .get(`${this.baseUrl}/getLibrary/${id}`)
      .map(result => result.json().data as ItemLibrary);
  }

  getLibraryBySystem(systemCode: string, id: string): Observable<ItemLibrary> {
    return this.sxHttp
      .get(`${this.baseUrl}/getLibraryBySystem/${systemCode}/${id}`)
      .map(result => result.json().data as ItemLibrary);
  }

  /**
   * Return all a parametrization from the library
   * @param id the Id to search
   */
  getFullParametrization(id: string): Observable<ItemParametrization> {
    let url = `${this.baseUrl}/getFullParametrization/${id}`;

    return this.sxHttp
      .get(url)
      .map(result => result.json().data as ItemParametrization);
  }

  /**
   * Return all a parametrization from the library
   * @param id the Id to search
   * @param systemCode the systemCode to search
   */
  getParametrization(id: string, systemCode: string, businessCode?: string): Observable<any> {
    let url = `${this.baseUrl}/getParametrization/${id}/${systemCode}/${businessCode}`;

    return this.sxHttp
      .get(url)
      .map(result => result.json().data as ItemLibrary);
  }

  /**
   * service to register new library
   *
   * @param systemCode the code System
   * @param id the library
   * @param items list of the item Parametrization to change
   */
  parametrize(systemCode: string, id: string, items: ItemParametrization): Observable<any> {
    return this.sxHttp
      .post(`${this.baseUrl}/parametrize/${systemCode}/${id}`, items)
      .map(response => response.json().data as any);
  }

  /**
   * service to register new library
   *
   * @param id the library
   */
  saveOrEditBySystem(library: ItemLibrary, systemCode: string): Promise<any> {
    return this.sxHttp
      .post(`${this.baseUrl}/save/${systemCode}`, library)
      .toPromise()
      .then(result => {
        const res = result.json().data as ItemLibrary;
      });
  }

  saveOrEdit(library: ItemLibrary,): Promise<any> {
    return this.sxHttp
      .post(`${this.baseUrl}/save/`, library)
      .toPromise()
      .then(result => {
        const res = result.json().data as ItemLibrary;
      });
  }

  /**
   * delete smartix Library in database
   */
  Delete(id: string): Observable<any> {
    return this.sxHttp
      .delete(`${this.baseUrl}/delete/${id}`)
      .map(result => result.json().data);
  }

  getInsurance(): any {
    let insurances = [
      {
        id: '1',
        name: 'Allianz'
      },
      {
        id: '2',
        name: 'Atm'
      },
      {
        id: '3',
        name: 'Barkley'
      },
      {
        id: '4',
        name: 'Boston'
      },
      {
        id: '5',
        name: 'Federacion Patronal'
      },
      {
        id: '6',
        name: 'Generalli'
      },
      {
        id: '7',
        name: 'HSBC'
      },
      {
        id: '8',
        name: 'La Caja'
      },
      {
        id: '9',
        name: 'Galicia Seguros'
      },
      {
        id: '10',
        name: 'Zurich'
      }
    ]
    return insurances;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/itemLibrary.service.ts